import { OptionType } from '@medely/ui-kit';

export const EMPLOYMENT_TYPE_OPTIONS: OptionType[] = [
  { value: 0, label: 'Per diem' },
  { value: 1, label: 'Full Time' },
  { value: 2, label: 'Part Time' },
  { value: 3, label: 'Travel contract' },
  { value: 4, label: 'Internship' },
];

export const NON_CLINICAL_EMPLOYMENT_TYPE_OPTIONS: OptionType[] = [
  { value: 1, label: 'Full Time' },
  { value: 2, label: 'Part Time' },
];

export const YES_NO_OPTIONS = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const NON_CLINICAL_FIELDS = [
  'clinical',
  'position_title',
  'currently_work_here',
  'start_date',
  'end_date',
  'employment_type',
  'description',
  'organization_name',
  'location',
  'state_id',
  'id',
];
